import { site, genericWhatsappLink } from "@/content/liane-site.ar";
import { WhatsAppIcon } from "./WhatsAppIcon";
import heroImage from "@/assets/liane/hero-soap.jpg.asset.json";

export function Hero() {
  return (
    <section id="home" className="relative overflow-hidden pt-24 pb-14 lg:pt-32 lg:pb-24">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 start-[-10%] size-[36rem] rounded-full bg-l-accent-soft/60 blur-3xl"
      />
      <div className="container-liane relative grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
        <div className="text-start">
          <span className="inline-flex items-center rounded-full border border-l-border bg-l-accent-soft px-4 py-2 text-xs font-medium text-l-accent-strong-foreground sm:text-sm">
            {site.hero.eyebrow}
          </span>
          <h1 className="mt-5 text-[1.95rem] font-bold text-l-primary sm:text-4xl lg:text-[3.25rem]">
            {site.hero.h1}
          </h1>
          <p className="mt-5 max-w-xl text-base text-l-muted-foreground sm:text-lg">
            {site.hero.sub}
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={genericWhatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-[3.25rem] items-center justify-center gap-2 rounded-full bg-l-primary px-7 text-base font-medium text-l-primary-foreground shadow-l-soft transition-transform hover:brightness-110 active:scale-[0.99]"
            >
              <WhatsAppIcon className="size-5" />
              {site.hero.ctaPrimary}
            </a>
            <a
              href="#gallery"
              className="inline-flex min-h-[3.25rem] items-center justify-center rounded-full border border-l-primary/25 px-7 text-base font-medium text-l-primary transition-colors hover:bg-l-accent-soft"
            >
              {site.hero.ctaSecondary}
            </a>
          </div>
        </div>

        <div className="relative">
          <img
            src={heroImage.url}
            alt={site.hero.imageAlt}
            width={1200}
            height={1200}
            {...{ fetchpriority: "high" }}
            className="aspect-square w-full rounded-3xl border border-l-border object-cover shadow-l-lift"
          />
        </div>
      </div>
    </section>
  );
}
